export const EXSBMEASURE_SHOW_RESET = 'EXSBMEASURE_SHOW_RESET'
export const EXSBMEASURE_SHOW_SET_ERROR = 'EXSBMEASURE_SHOW_SET_ERROR'
export const EXSBMEASURE_SHOW_SET_RETRIEVED = 'EXSBMEASURE_SHOW_SET_RETRIEVED'
export const EXSBMEASURE_SHOW_TOGGLE_LOADING = 'EXSBMEASURE_SHOW_TOGGLE_LOADING'
